import { LevelList } from '../Inamove/Containers/LevelListContainer/LevelListContainer'

const levelList: LevelList = [
    {
        id: 'intro',
        name: 'Intro',
        code: '0',
    },
    {
        id: 'level1',
        name: 'Unordentliche Bewerbungsunterlagen',
        code: '1',
    },
    {
        id: 'level2',
        name: 'Der Quizmaster',
        code: '2',
    },
    {
        id: 'level3',
        name: 'Lisa und die Zukunft',
        code: '3',
    },
    {
        id: 'level4',
        name: 'Der erste Arbeitstag',
        code: '4',
    },
    {
        id: 'level5',
        name: 'Der Anruf',
        code: '5',
    },
    {
        id: 'level6',
        name: 'Die traurige Putzfrau',
        code: '6',
    },
    {
        id: 'level7',
        name: 'Der Doppelgänger',
        code: '7',
    },
    {
        id: 'level8',
        name: 'Die göttliche Erscheinung',
        code: '8',
    },
    {
        id: 'level9',
        name: 'So ein Affentheater',
        code: '9',
    },
    {
        id: 'level10',
        name: 'Stille Wasser sind tief',
        code: '10',
    },
    {
        id: 'level11',
        name: 'Unter der Oberfläche',
        code: '11',
    },
    {
        id: 'level12',
        name: 'Die Zeitkiste',
        code: '12',
    },
    {
        id: 'level13',
        name: 'Die Geisterstadt und die Zeichen der Zeit',
        code: '13',
    },
    {
        id: 'level14',
        name: 'Ein falsches Wort',
        code: '14',
    },
    {
        id: 'level15',
        name: 'Ende',
        code: '15',
    },
    {
        id: 'level16',
        name: 'Abspann',
        code: '16',
    },
]

export default levelList
